import axios from 'axios';

import { API_BASE_URL } from '../constants';
import { PlantUpdate, Plant, NewPlant } from '../../../src/types';

const getPlants = async () => {
    const { data: plants } = await axios.get<Plant[]>(`${API_BASE_URL}/plants`)
    return plants;
};

const getPlant = async (id: Plant["id"]) => {
    const {data: plant} = await axios.get<Plant>(`${API_BASE_URL}/plants/${id}`);
    return plant;
};

const addPlant = async (newPlant: NewPlant) => {
    const { data: plant } = await axios.post<Plant>(`${API_BASE_URL}/plants`, newPlant);
    return plant;
};

const updatePlant = async (id:Plant["id"], plantUpdate: PlantUpdate) => {
    const {data: updatedPlant} = await axios.put(`${API_BASE_URL}/plants/${id}`, plantUpdate);
    return updatedPlant;
};

const deletePlant = async (id: Plant["id"]) => {
    await axios.delete(`${API_BASE_URL}/plants/${id}`);
}

const waterPlant = async(id: Plant["id"]) => {
    await axios.get(`${API_BASE_URL}/plants/${id}/water`);
};

const controlPlant = async(id: Plant["id"]) => {
    await axios.get(`${API_BASE_URL}/plants/${id}/control`);
};

const calibratePlant = async(id: Plant["id"]) => {
    await axios.get(`${API_BASE_URL}/plants/${id}/calibrate`)
}

const getPlantReadings = async(id: Plant["id"], hours:number) => {
    const {data: readings} = await axios.get(`${API_BASE_URL}/plants/${id}/readings?hours=${hours}`)
    return readings
};

const getPlantEvents = async(id: Plant["id"], hours:number) => {
    const {data: events} = await axios.get(`${API_BASE_URL}/plants/${id}/events?hours=${hours}`);
    return events
};

const service = { 
    updatePlant,
    getPlant,
    getPlants,
    getPlantReadings,
    getPlantEvents,
    waterPlant,
    addPlant,
    deletePlant,
    controlPlant,
    calibratePlant
};
export default service;